"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInterstitialBase = void 0;
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const useInterstitialService_hook_1 = require("./useInterstitialService.hook");
const GLOBAL_POSITION_PATH = '/global-position';
const useInterstitialBase = (repository) => {
    const { getInterstitialCall, isInterstitialSuccess, interstitialData, isDataEmpty, resetInterstitial } = (0, useInterstitialService_hook_1.useInterstitialService)(repository);
    const location = (0, react_router_dom_1.useLocation)();
    (0, react_1.useEffect)(() => {
        if (location.pathname === GLOBAL_POSITION_PATH) {
            getInterstitialCall();
        }
        return () => {
            resetInterstitial();
        };
    }, [location.pathname]);
    return {
        interstitialData: interstitialData?.data,
        type: interstitialData?.data?.type,
        showInterstitial: isInterstitialSuccess && !isDataEmpty,
    };
};
exports.useInterstitialBase = useInterstitialBase;
//# sourceMappingURL=useInterstitialBase.hook.js.map